import { Formik, FormikHelpers } from "formik";
import { useFormSubmit } from "melco-shared-logic";
import { DirtyFormPrompt } from "../../form/DirtyFormPrompt";
import { Drawer as DrawerType } from "../../../hooks/drawer/useGenericDrawer";
import { useState } from "react";
import { DisplayExtendTrialForm } from "./DisplayExtendTrialForm";
import { ExtendTrialActionButton, ExtendTrialActionButtonInterface } from "../ExtendTrialActionButton";

export type SubmitAction = "Generate";

type ExtendTrialFormValueType = {
  extendTrialDateTime: Date;
  ExtendTrialActionDetails: ExtendTrialActionButtonInterface;
};

type ExtendTrialFormProps = {
  referenceDrawer: DrawerType
  onCloseDrawer: (closeDrawer: boolean) => void;
  ExtendTrialActionDetails: ExtendTrialActionButtonInterface;
};

export const ExtendTrialForm: React.FC<ExtendTrialFormProps> = ({
  ExtendTrialActionDetails,
  referenceDrawer,
  onCloseDrawer
}) => {
  const [openAskConirmationBoxTrigger, setOpenAskConfirmationBoxTrigger] = useState(false);
  const [showConfimationPopUpVar, setShowConfimationPopUpVar] = useState<boolean>(false);

  //const [newTrialDate, setNewTrialDate] = useState<Date>();


  const onSubmit = async (
    values: ExtendTrialFormValueType,
    formikHelpers: FormikHelpers<ExtendTrialFormValueType>
  ) => {


    //setNewTrialDate(values.extendTrialDateTime)
    ExtendTrialActionDetails.extendTrialDateTime = values.extendTrialDateTime
    setShowConfimationPopUpVar(true);
    await onExtendTrial(values, formikHelpers);

  };

  const initialValues = {
    extendTrialDateTime: new Date(),
    ExtendTrialActionDetails: ExtendTrialActionDetails
  };

  const handleExtendTrial = async (
    values: ExtendTrialFormValueType,
    formikHelpers: FormikHelpers<ExtendTrialFormValueType>,
    options: {

    }
  ) => {
    setOpenAskConfirmationBoxTrigger(!openAskConirmationBoxTrigger);

  };

  const formSubmitToExtendTrial = () => {

    return [
      async (
        values: ExtendTrialFormValueType,
        formikHelpers: FormikHelpers<ExtendTrialFormValueType>
      ) => {
        return handleExtendTrial(values, formikHelpers, {});
      },
      {
        translationOptions: {
          batchNumber: 1,
        },
        translationPrefix: "",
        onError: () => {

        },
      },
    ] as const;
  };

  const onExtendTrial = useFormSubmit(...formSubmitToExtendTrial());


  return (


    <>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
      >

        <DirtyFormPrompt>
          <DisplayExtendTrialForm referenceDrawer={referenceDrawer} />
        </DirtyFormPrompt>
      </Formik>

      {showConfimationPopUpVar && <ExtendTrialActionButton
        ExtendTrialActionDetails={{

          "product_code": ExtendTrialActionDetails.product_code,
          "extendTrialDateTime": ExtendTrialActionDetails.extendTrialDateTime,
          "userIdToExtendTrial": ExtendTrialActionDetails.userIdToExtendTrial,
          "product_version_number": ExtendTrialActionDetails.product_version_number
        }}
        referencesDrawer={referenceDrawer}
        openAskConirmationBoxTrigger={openAskConirmationBoxTrigger}
        onCloseDrawer={onCloseDrawer}
      ></ExtendTrialActionButton>
      }
    </>

  );
};
